/**
 * nav-toggle.js
 * ハンバーガーメニューの開閉
 *
 * 【仕様】
 * - .js-menu-trigger が存在しないページでは何もしない
 * - トリガーをクリックすると body の data-nav-visible を "true" / "false" でトグルする
 * - data-nav-visible は CSS 側でメニューの表示・非表示の制御に使用する
 *
 * 【使い方】
 * initNavToggle();
 *
 * 【マークアップ例】
 * <button class="js-menu-trigger">メニュー</button>
 */

export function initNavToggle() {
  const triggers = document.querySelectorAll('.js-menu-trigger');
  if (!triggers.length) return;

  const body = document.querySelector('body');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      body.dataset.navVisible = body.dataset.navVisible !== 'true';
    });
  });
}
